'use client'

import { ExperimentsContext } from 'app/_components/ExperimentsSwitcher'
// SP-webではcrypto.subtleが使えないため、js-sha256を使用
import { sha256 } from 'js-sha256'
import { useContext, useEffect, useState } from 'react'
import { getAnonymousUserId } from '~/libs/anonymousUserId'

export const EXPERIMENTS = {
  test1: '架空のテスト1',
  showFanReviews: 'ファンのレビュー表示',
  recommendedTrailerKeyVisual: 'キービジュアルを推薦予告に変更',
  publicBackgroundBaseBlack: 'public 画面の背景を Base/Black 単色に変更',
}
export type ExperimentName = keyof typeof EXPERIMENTS
export const EXPERIMENT_NAMES: ExperimentName[] = Object.keys(EXPERIMENTS) as ExperimentName[]

export const calcIsTreatment = (experimentName: ExperimentName): boolean => {
  const userId = getAnonymousUserId()
  const input = `${userId}${experimentName}`

  const hash = sha256(input)
  const lastByte = parseInt(hash.slice(-2), 16) // 末尾の整数を取得
  return lastByte % 2 === 1
}

/**
 * A/Bテスト用カスタムフック
 * - 匿名ユーザーIDとexperimentNameのSHA-256ハッシュ値でグループを決定
 *   （最下位バイトが奇数ならtrue("treatment")、偶数ならfalse("control")）
 */
export const useExperiment = (experimentName: ExperimentName): boolean | null => {
  const experiments = useContext(ExperimentsContext)
  const [isTreatment, setIsTreatment] = useState<boolean | null>(
    experiments?.[experimentName] ?? null,
  )

  useEffect(() => {
    setIsTreatment(experiments?.[experimentName] ?? calcIsTreatment(experimentName))
  }, [experimentName, experiments])

  return isTreatment
}
